const MedalistPhase2Category = ({ text }: { text: string }) => {
  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <div className='mb-[5px] md:mb-[8px] lg:mb-[16px] font-abcd uppercase font-extrabold text-[15px] md:text-[31.83px] md:font-[800] md:leading-[100%] md:tracking-[-0.05em] md:align-bottom md:uppercase lg:text-[28.24px] leading-[100%] tracking-[-5%] align-bottom'>
        {text}
      </div>
      {/* horizontal line */}
      <div className='w-full h-[0.25px] md-h-[0.5px] lg-h-[1px] bg-black mb-[5px] md:mb-[8px] lg:mb-[16px]' />
    </div>
  )
}

export default MedalistPhase2Category
